import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NoticeInfo } from "api/interfaces/noticeInterface.interface";
import {
  ReleaseVersion,
  ReleaseVersionMessagePayload,
} from "api/interfaces/releaseInterface.interface";
import { isVersionGreater } from "utils/functions";

export interface NoticeState {
  notices: NoticeInfo[];
  release: ReleaseVersion;
}

const initialState: NoticeState = {
  notices: [],
  release: {
    description: "",
    installedVersion: "",
    latestVersion: "",
    needToUpdate: false,
  },
};

export const noticeSlice = createSlice({
  name: "notices",
  initialState,
  reducers: {
    setNotices: (state, { payload }: PayloadAction<NoticeInfo[]>) => {
      state.notices = payload;
    },
    deleteNotice: (state, { payload }: PayloadAction<string>) => {
      state.notices.map((item, index) => {
        if (item.noticeId === payload) {
          state.notices.splice(index, 1);
        }
      });
    },
    updateNotice: (state, { payload }: PayloadAction<NoticeInfo>) => {
      const index = state.notices.findIndex(
        (not) => not.noticeId === payload.noticeId
      );

      if (index !== -1) {
        state.notices[index] = { ...state.notices[index], ...payload };
      } else {
        state.notices.push(payload);
      }
    },
    updateReleaseVersion: (
      state,
      { payload }: PayloadAction<ReleaseVersionMessagePayload>
    ) => {
      state.release = {
        ...payload,
        needToUpdate: !isVersionGreater({
          installedVersion: process.env.REACT_APP_VERSION ?? "",
          latestVersion: payload.latestVersion,
        }),
      };
    },
  },
});

export const { setNotices, deleteNotice, updateNotice, updateReleaseVersion } =
  noticeSlice.actions;

export default noticeSlice.reducer;
